import { render, staticRenderFns } from "./Lodging.vue?vue&type=template&id=15abaa5d&scoped=true&"
import script from "./Lodging.vue?vue&type=script&lang=js&"
export * from "./Lodging.vue?vue&type=script&lang=js&"
import style0 from "./Lodging.vue?vue&type=style&index=0&id=15abaa5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abaa5d",
  null
  
)

export default component.exports